import { FilterParams, FilterValues, StatusFilterOption } from "../@types/filter";
import { Status } from "../enums/Status";

interface filterOptions {
  [key: string]: StatusFilterOption;
}

export const getAdvanceFilterValue = (param: string, isMobile: boolean): boolean | null => {
  if (param === "true") return true;
  if (isMobile && !param) return false;
  if (isMobile && param === "true") return true;
  return null;
};

export const filterToParams = (filters: FilterValues, page?: number, size?: number, sort?: string): FilterParams => {
  // console.log(filters);
  const params: FilterParams = {
    collaborator: filters?.collaborator?.id || null,
    collaboratorName: filters?.collaboratorName || null,
    ownerName: filters?.ownerName || null,
    costCenter: filters?.costCenter || null,
    expendCategory: filters?.expenseCategory || null,
    financialApproveDateUntil: filters?.financialApproveDateUntil || null,
    financialApproveDateAfter: filters?.financialApproveDateAfter || null,
    ownerApprovedDateUntil: filters?.ownerApprovedDateUntil || null,
    ownerApprovedDateAfter: filters?.ownerApprovedDateAfter || null,
    createDateUntil: filters?.createDateUntil || null,
    createDateAfter: filters?.createDateAfter || null,
    startExpenseDate: filters?.startDate || null,
    endExpenseDate: filters?.endDate || null,
    reportEntryStatus: filters?.statusFilter?.status || null,
    ownerApproved: filters?.statusFilter?.ownerApproved,
    finnancialApproved: filters?.statusFilter?.financialApproved,
    isAdvance: filters?.isAdvance,
    isPendingPayment: filters?.statusFilter?.isPendingPayment === true ? true : null,
    clientRefund: filters?.clientRefund,
  };

  if (page !== undefined) {
    params.page = page;
  }

  if (size !== undefined) {
    params.size = size;
  }

  if (sort !== undefined) {
    params.sort = sort;
  }

  return params;
};

export const statusFilterOptions: filterOptions = {
  all: {
    key: "all",
    name: "Todos em Aprovação",
    status: Status.ON_APPROVAL,
    ownerApproved: undefined,
    financialApproved: undefined,
  },
  pendingOwner: {
    key: "pendingOwner",
    name: "Pendente Aprovação Gestor",
    status: Status.ON_APPROVAL,
    ownerApproved: false,
    financialApproved: undefined,
  },
  pendingFinance: {
    key: "pendingFinance",
    name: "Pendente Aprovação Financeiro",
    status: Status.ON_APPROVAL,
    ownerApproved: undefined,
    financialApproved: false,
  },
  approved: {
    key: "approved",
    name: "Aprovados",
    status: Status.APPROVED,
    ownerApproved: undefined,
    financialApproved: undefined,
  },
  refused: {
    key: "refused",
    name: "Rejeitados",
    status: Status.REFUSED,
    ownerApproved: undefined,
    financialApproved: undefined,
  },
  financialValidation: {
    key: "financialValidation",
    name: "Aguardando Validação Financeiro",
    status: Status.FINANCIAL_VALIDATION,
    ownerApproved: undefined,
    financialApproved: undefined,
  },
  paid: {
    key: "paid",
    name: "Pago",
    status: Status.PAID,
    ownerApproved: undefined,
    financialApproved: undefined,
  },
  pendingPayment: {
    key: "pendingPayment",
    name: "Pendente Pagamento",
    status: undefined,
    ownerApproved: undefined,
    financialApproved: undefined,
    isPendingPayment: true,
  },
};
